"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import type { LoaderRenderProps } from "react-joyride";
import { LoadingSpinner } from "@/components/ui/LoadingSpinner";
export function TourLoader(_props) {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LoadingSpinner className="pointer-events-none" innerSpinner={{
      className: "size-6 border-2 border-muted border-t-primary"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}